import fi from "./locales/fi";
import en from "./locales/en";
export default () => ({
	legacy: false,
	locale: "fi",
	fallbackLocale: "en",
	messages: {
		en,
		fi
	}
});
